import { requestGet, requestPost, requestUpload, removeToken } from '@/utils/request';

const api = {
    LOGIN: '/login',
    ADMIN_INFO: '/app/admin_info',
    SETTING: '/app/setting',
    SETTING_ITEM: '/app/setting_item',
    SETTING_PASSWORD: '/app/setting_password',
    UPLOAD_IMAGE: '/app/upload_image',
	UPLOAD_VOICE: '/app/upload_voice',
	UPLOAD_APP: '/app/upload_app',
	UPLOAD_SVGA: '/app/upload_svga',
	UPLOAD_VIDEO: '/app/upload_video',
	GOOGLE_AUTH_IS_OPEN: '/google_auth_is_open',
}

export async function login(params) {
     return requestPost(api.LOGIN, params);
}

export function logout() {
    removeToken();
}

export async function adminInfo() {
    return requestGet(api.ADMIN_INFO);
}

export async function permissions() {
    return requestGet(api.ADMIN_INFO);
}

export async function setting() {
    return requestPost(api.SETTING);
}

export async function setItem(form) {
    return requestPost(api.SETTING_ITEM, form);
}

export async function setPassword(form) {
    return requestPost(api.SETTING_PASSWORD, form);
}

export async function uploadImage(form) {
    return requestUpload(api.UPLOAD_IMAGE, form);
}

export async function uploadVoice(form) {
    return requestUpload(api.UPLOAD_VOICE, form);
}

export async function uploadApp(form) {
    return requestUpload(api.UPLOAD_APP, form);
}

export async function uploadSvga(form) {
    return requestUpload(api.UPLOAD_SVGA, form);
}

export async function uploadVideo(form) {
    return requestUpload(api.UPLOAD_VIDEO, form);
}

export async function googleAuthIsOpen() {
    return requestGet(api.GOOGLE_AUTH_IS_OPEN);
}